import { render, staticRenderFns } from "./PbcPosts.vue?vue&type=template&id=da6f64e8&"
import script from "./PbcPosts.vue?vue&type=script&lang=js&"
export * from "./PbcPosts.vue?vue&type=script&lang=js&"
import style0 from "./PbcPosts.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports